import IdeyaTypography from '../../../../../common/antd/ideya-typography.tsx'
import { NEW_RELIC, newRelic } from '../../../../../utils/new-relic.ts'
import { useTranslation } from 'react-i18next'

interface InvalidTickerMessageProps {
  message: string
  ticker: string
}

export const InvalidTickerMessage: React.FC<InvalidTickerMessageProps> = ({
  message,
  ticker,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <IdeyaTypography.Text type={'danger'}>{message}</IdeyaTypography.Text>
      <a
        type={'link'}
        onClick={() => {
          newRelic.addPageAction(NEW_RELIC.PAGE_ACTION.createIdeaEmailedSupport)
        }}
        href={`mailto:support@polymerideya.com?subject=Requesting to make ${ticker} active`}
      >
        {t('idea_list.idea_modal.action_idea_form.email_support')}
      </a>
    </>
  )
}
